export interface ILessonPage {
    activityId: string;
    classId?: string | null;
}

export interface IState {
    classInformation: { courseName: string, programName: string, teacher: Array<any>, logoUrl: string, courseDescription: string };
    isLoaded: boolean;
    error: boolean;
    firstTwoTeachers: Array<string>;
}

export enum ActivityType {
    Other = 'Other',
    Assignment = 'Assignment',
    Course = 'Course',
    Elesson = 'Elesson',
    Exam = 'Exam',
    Forum = 'Forum',
    Document = 'Document',
    VirtualClass = 'VirtualClass',
    Container = 'Container',
    Survey = 'Survey',
    Video = 'Video',
    MorpaActivity = 'MorpaActivity',
    GenericActivity = 'GenericActivity',
    LinkActivity = 'LinkActivity',
    DersdeoActivity = 'DersdeoActivity',
    Dictionary = 'Dictionary',
    TelegramActivity = 'TelegramActivity',
    Reading = 'Reading',
    LTIActivity = 'LTIActivity',
    Project = 'Project',
    InformationNote = 'InformationNote'
}

